/* eslint-disable @typescript-eslint/no-explicit-any */
import { StatusEnum } from 'app/common/enum'
import { ClinicTypeEnum } from 'app/containers/HumanResources/UnitManagement/type'
import { IMetadata, ResponseType } from 'parkway-web-common'

export interface IUnitManagement {
  _id?: string
  code?: string
  name?: string
  unitGroupId?: string
  unitGroupName?: string
  unitTypeId?: string
  jobTitleIdManagement?: string
  jobTitleIdVice?: string
  unitTypeName?: string
  parentid?: string
  oldid?: string
  description?: string
  status?: number
  createddate?: string
  children?: Array<IUnitManagement>
  unitParentCode?: string
  unitParentName?: string
  clinicType?: ClinicTypeEnum
}

export type IResponseGetUnitManagement = ResponseType<{
  rows: IUnitManagement[]
  metadata: IMetadata
}>

export enum TypeId {
  DEPARTMENT = 'department',
  CLINIC = 'clinic',
  AREA = 'area',
}

export interface IParamsGetUnitManagement {
  keyword?: string
  status?: StatusEnum[] | number
  pageSize?: number
  page?: number,
  typeid?: string
  pagesize?: number
}

export interface IPayloadCreateUnitManagement {
  code?: string
  name?: string
  unitGroupId?: string
  unitTypeId?: string
  jobTitleIdManagement?: string
  description?: string
  status?: StatusEnum
  jobTitleIdVice?: string
  clinicType?: ClinicTypeEnum
}

export interface IPayloadCreateUnitChild {
  code?: string
  name?: string
  unitGroupId?: string
  unitTypeId?: string
  jobTitleIdManagement?: string
  description?: string
  status?: StatusEnum
  parentid?: string
  jobTitleIdVice?: string
  clinicType?: ClinicTypeEnum
}

export interface IPayloadUpdateUnitManagement {
  code?: string
  name?: string
  unitGroupId?: string
  unitTypeId?: string
  jobTitleIdManagement?: string
  description?: string
  status?: StatusEnum
  _id?: string
  parentid?: string
  jobTitleIdVice?: string
  clinicType?: ClinicTypeEnum
}

export interface IAllUnit {
  rows: IUnit[]
}
export interface IUnit {
  _id?: string
  code?: string
  name?: string
  description?: string
  typeid?: TypeId
  unitTypeStringId?: TypeId
  status?: number
  createduserid?: string
  createddate?: string
  updateddate?: string
}
